export const GLOBAL_RECOMMENDATIONS_LABEL = 'global.recommendations';
export const lblCtaText = 'CTA_TEXT';

export const GlobalRecommendationLabels = {
  global: {
    recommendations: {
      [lblCtaText]: 'Shop Now',
    },
  },
};
